// eslint-disable-next-line import/prefer-default-export
export enum Store {
  default = 'default',
  en = 'hbeu_en',
  de = 'hbeu_de',
  fr = 'hbeu_fr',
  es = 'hbeu_es',
}
